import $ from 'jquery';
import debounce from 'lodash/debounce';
import bind from 'lodash/bind';
import get from 'lodash/get';

import './CheckoutAutoComplete.scss';
import template from './CheckoutAutoComplete.vhtml';

export default {
	name: 'CheckoutAutoComplete',
	template: template,
	props: {
		inputFields: {
			type: Object,
			default: null,
		},
		runWipeData: {
			type: Boolean,
		},
	},
	data: () => ({
		clonedFields: null,
		isFetching: false,
		hasTimeout: false,
	}),
	computed: {
		cvr: vm => get(vm, 'clonedFields.billing_cvr', ''),
		company: vm => get(vm, 'clonedFields.billing_company', ''),
	},
	watch: {
		cvr() {
			if (this.cvr === '') {
				this.$options.autoComplete.cancel();
			} else if (/^[0-9]{8}$/.test(this.cvr)) {
				const param = {
					cvr: this.cvr
				};
				this.autoComplete(param);
			}
		},
		company() {
			if (this.company === '') {
				this.$options.autoComplete.cancel();
			} else {
				const param = {
					company: this.company
				};
				this.autoComplete(param);
			}
		},
		runWipeData() {
			this.wipeData();
		}
	},
	methods: {
		autoComplete(param) {
			if (!this.hasTimeout) {
				this.$options.autoComplete(param);
			}
		},
		wipeData() {
			Object.keys(this.clonedFields).forEach(key => {
				this.clonedFields[key] = '';
			});
		},
	},
	created() {
		this.$options.autoComplete = debounce(bind(autoComplete, this), 1000);
		this.clonedFields = get(this, 'inputFields');
	},
};

function autoComplete(param) {
	const endpoint = '/wp-json/be/v1/cvr-lookup/';
	this.isFetching = true;
	getRequest(endpoint, param)
		.then(result => {
			if (typeof result != 'object') {
				result = JSON.parse(result)
			}

			if (result.message === 'One hit') {
				this.hasTimeout = true;

				if (get(this, 'clonedFields.billing_cvr', null) !== null){
                    if(get(result, 'data.cvr', '') == false){
                        this.clonedFields.billing_cvr = null;
                    } else {
                        this.clonedFields.billing_cvr = get(result, 'data.cvr', '');
                    }
                } 

                if (get(this, 'clonedFields.billing_company', null) !== null){
                    if(get(result, 'data.company', '') == false){
                        this.clonedFields.billing_company = null;
                    } else {
                        this.clonedFields.billing_company = get(result, 'data.company', '');
                    }
                } 

                if (get(this, 'clonedFields.billing_email', null) !== null){
                    if(get(result, 'data.email', '') == false){
                        this.clonedFields.billing_email = null;
                    } else {
                        this.clonedFields.billing_email = get(result, 'data.email', '');
                    }
                } 

                if (get(this, 'clonedFields.billing_address_1', null) !== null){
                    if(get(result, 'data.addr', '') == false){
                        this.clonedFields.billing_address_1 = null;
                    } else {
                        this.clonedFields.billing_address_1 = get(result, 'data.addr', '');
                    }
                } 

                if (get(this, 'clonedFields.billing_postcode', null) !== null){
                    if(get(result, 'data.address.zip', '') == false){
                        this.clonedFields.billing_postcode = null;
                    } else {
                        this.clonedFields.billing_postcode = get(result, 'data.address.zip', '');
                    }
                } 

                if (get(this, 'clonedFields.billing_city', null) !== null){
                    if(get(result, 'data.address.city', '') == false){
                        this.clonedFields.billing_city = null;
                    } else {
                        this.clonedFields.billing_city = get(result, 'data.address.city', '');
                    }
                } 

				// if (get(this, 'clonedFields.billing_company', null) !== null || false) this.clonedFields.billing_company = get(result, 'data.company', '');

				// if (get(this, 'clonedFields.billing_email', null) !== null || false) this.clonedFields.billing_email = get(result, 'data.email', '');

				// if (get(this, 'clonedFields.billing_address_1', null) !== null || false) this.clonedFields.billing_address_1 = get(result, 'data.address.addr', '');

				// if (get(this, 'clonedFields.billing_postcode', null) !== null || false) this.clonedFields.billing_postcode = get(result, 'data.address.zip', '');

				// if (get(this, 'clonedFields.billing_city', null) !== null || false) this.clonedFields.billing_city = get(result, 'data.address.city', '');

				this.$nextTick(() => {
					this.hasTimeout = false;
				});
			}
		})
		.always(() => this.isFetching = false);
}

/**
 * Make request to WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getRequest(endpoint, params) {
	return $.get(endpoint, params);
}
